import {
    FinancialAccount,
    FinancialAccountBase,
    FinancialAccountSourceType,
} from "./financialAccount";
import {
    FinancialConnection,
    FinancialConnectionBase,
} from "./financialConnection";
import { FinancialDocumentBase } from "./financialDocument";
import {
    IntegrationConnection,
    IntegrationConnectionBase,
} from "./integrationConnection";

export enum InvoiceJournalEntryMode {
    ALWAYS = "always",
    INFER = "infer",
    NEVER = "never",
}

/**
 * Base type for IntegrationAccount - allows undefined on relations.
 * Used by entity classes (TypeORM).
 */
export interface IntegrationAccountBase {
    id: string;
    connectionId: number | null;
    integrationConnectionId: string | null;
    sourceType: FinancialAccountSourceType;
    sourceAccountId: string | null;
    balanceSyncedAt: Date | null;
    transactionsSyncedAt: Date | null;
    invoicesSyncedAt: Date | null;
    statementsSyncedAt: Date | null;
    lastStatementDate: string | null;
    createdAt: Date | null;
    invoiceJournalEntryMode: InvoiceJournalEntryMode;
    financialAccountId: number | null;
    financialAccount?: FinancialAccountBase | null;
    financialDocument?: FinancialDocumentBase | null;
    connection?: FinancialConnectionBase | null;
    integrationConnection?: IntegrationConnectionBase | null;
    metadata: any;
}

/**
 * Strict type for IntegrationAccount - requires loaded relations.
 * Used by DTOs and service boundaries after relations are loaded.
 */
export interface IntegrationAccount extends Omit<
    IntegrationAccountBase,
    | "financialAccount"
    | "financialDocument"
    | "connection"
    | "integrationConnection"
> {
    financialAccount: FinancialAccount | null;
    financialDocument?: FinancialDocumentBase | null;
    connection: FinancialConnection | null;
    integrationConnection?: IntegrationConnection | null;
}
